import { useApi } from '../services';

export const useGetQuestionnairesById = (idQuestionnaire) => useApi(
    `/v2/questionnaire/${idQuestionnaire}`,
    'GET',
    {},
    {}
);

export const useGetQuestionnairesByIdProduct = (idProduct) => useApi(
    `/v2/questionnaire/product/${idProduct}`,
    'GET',
    {},
    {}
);

export const useGetCountries = (query) => useApi(
    `/v2/questionnaire/options/country`,
    'GET',
    { ...query },
    {},
    true
);

export const useGetStatusOptions = () => useApi(
    `/v2/questionnaire/options/status`,
    'GET',
    {},
    {},
    true
);

export const useGetDomainStatus = () => useApi(
    `v2/domain-status`,
    'GET',
    {},
    {},
    true
  );

export const useGetProductOptions = () => useApi(
    `/v2/questionnaire/options/product`,
    'GET',
    {},
    {},
    true
);

export const useGetSerpro = () => useApi(
    `/serpro/cnpj`,
    'GET',
    {},
    {},
    true
);

export const useGetSerproEnterprise = () => useApi(
    `sompo/get-cnpj`,
    'GET',
    {},
    {},
    true
);

export const useGetZipCode = (zipCode) => useApi(
    `/correios/dne/${zipCode}`,
    'GET',
    {},
    {},
    true
);

export const useGetQuery = () => useApi(
    `/query`,
    'POST',
    {},
    {},
    true
);

export const useGetMonetaryCorrectionAsync = (idOperation) => useApi(
    `/v2/questionnaire/${idOperation}/options/monetary-correction`,
    'GET',
    {},
    {},
    true
);